import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TokenPair } from '../../models/token-pair';
import { WrappedResponse } from '../../models/wrapped-response';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthRepository {
  private readonly httpClient = inject(HttpClient);
  private readonly authUrl = `${environment.apiUrl}/auth`;

  logIn(username: string, password: string) {
    return this.httpClient.post<WrappedResponse<TokenPair>>(
      `${this.authUrl}/token`,
      { username, password }
    );
  }

  resetPassword(token: string, newPassword: string): Observable<HttpResponse<any>> {
    return this.httpClient.post<HttpResponse<any>>(
      `${this.authUrl}/reset-password`,
      { token, newPassword }
    );
  }

  forgotPassword(email: string): Observable<HttpResponse<any>> {
    return this.httpClient.post<HttpResponse<any>>(
      `${this.authUrl}/forgot`,
      { email }
    );
  }

  refreshTokens(refreshToken: string | null){
    return this.httpClient.post<WrappedResponse<TokenPair>>(
      `${this.authUrl}/refresh`,
      { refreshToken }
    );
  }
}
